// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth, indexedDBLocalPersistence, initializeAuth } from "firebase/auth";
import { isNativeApp } from "./native";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB4hgbaz_lAjd-rI7DJdmiEBbnd1prI7TU",
    authDomain: "tournamental-5653d.firebaseapp.com",
    projectId: "tournamental-5653d",
    storageBucket: "tournamental-5653d.firebasestorage.app",
    messagingSenderId: "273524378891",
    appId: "1:273524378891:web:d4cd4581da5077b515260e",
    measurementId: "G-HDK3CJ3DNF"
};

// Initialize Firebase
// (Analytics is started separately, and only with the person's consent: see analytics.js.)
export const app = initializeApp(firebaseConfig);
// Inside the phone app the default setup of Firebase Auth waits for a helper page from Google that never loads there, and the app
// then never learns whether somebody is signed in. Without the pop-up helper it starts at once (the phone has its own sign-in).
export const auth = isNativeApp()
    ? initializeAuth(app, { persistence: [indexedDBLocalPersistence, browserLocalPersistence] })
    : getAuth(app);
export const storage = getStorage(app);
